﻿<script>
	import { nanoid } from "nanoid";

	export let id = nanoid(6);
	export let label = null;
	export let sublabel = null;
	export let headOptionText = "Select...";
	export let value;
	export let optionList;
	export let textProperty = "name";
	export let valueProperty = "id";
	export let showHead = true;
	export let disabled = null;
	export let readonly = null;
	export let required = null;
	export let cntrl = null;

	let localValue = value === null ? "" : value;

	$: if (localValue !== (value === null ? "" : value)) {
		value = localValue;
	}
</script>

{#if label}
	<label for={id}>
		{label}

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}
	</label>
{/if}
<select {id} bind:value={localValue} {disabled} {readonly} {required} class="form-control" on:change bind:this={cntrl}>
	{#if showHead == true}
		<option value="">{headOptionText}</option>
	{/if}
	{#each optionList as item}
		<option value={item[valueProperty]}>{item[textProperty]}</option>
	{/each}
</select>

<style>
	select {
		position: relative;
		background-image: url(/img/br_down.png);
		background-position-y: center;
		background-repeat: no-repeat;
		background-attachment: initial;
		background-origin: content-box;
		background-clip: initial;
		background-position: right center;
		background-size: 10px;
	}

	select:after {
		content: "";
		position: absolute;
		top: 1px;
		left: 8px;
		border-bottom: 1px solid var(--color-border);
		border-right: 1px solid var(--color-border);
		transform: rotate(45deg);
		width: 14px;
		height: 14px;
	}
</style>
